//#region src/extensions/image-extension/utils/get-image-attrs.ts
var e = (e) => ({
	src: e?.getAttribute("src"),
	alt: e?.getAttribute("alt"),
	title: e?.getAttribute("title"),
	width: e?.getAttribute("width"),
	height: e?.getAttribute("height")
});
//#endregion
export { e as getImageAttrs };
